// extracted by mini-css-extract-plugin
export default {"tabs":"L--z","tablist":"M--z","tablistItem":"N--z"};